<script>
import FormInputGroupView, { FormInputGroup } from '@/components/form-input-group2/FormInputGroup';
import flywhweelSFMCUtilFactory from "@/services/flywheel-sfmc-util";
import DERowsTable from '@/components/DERowsTable';
import XLSX from "xlsx";
import downloadFiles from "@/services/download-files";
import QueryRunner from "@/services/ad-hoc-query-runner-2";

var formInputs = {
    contactInfo: [
        {
            "key": "contactAttributeType",
            "label": "Search contacts by:",
            "attrs": {
                "type": "radio"
            },
            "options": [
                {
                    "label": "SubscriberKey",
                    "value": "SubscriberKey"
                },
                {
                    "label": "EmailAddress",
                    "value": "EmailAddress"
                }
            ]
        },
        {
            "key": "emailAddresses",
            "label": `Email Addresses`,
            "attrs": {
                "type": "textarea",
                "required": true
            },
            'helperText': [
                `Comma or whitespace delimited list`
            ]
        },
        {
            "key": "subscriberKeys",
            "label": `Subscriber Keys`,
            "attrs": {
                "type": "textarea",
                "required": true
            },
            'helperText': [
                `Comma or whitespace delimited list`
            ]
        }
    ],
    eventTypesEmail: ['Sent', 'Open', 'Click', 'Bounce', 'Unsub', 'NotSent'].map((eventType) => (
        {
            "key": `eventType${eventType}`,
            "label": eventType,
            "attrs": {
                "type": "checkbox",
                "true-value": 'true',
                "false-value": 'false'
            }
        }
    )),
    filters: [
        {
            "key": "filterDateFrom",
            "label": "Date From",
            "attrs": {
                "type": "text",
                "pattern": "^[0-9]{4}-[0-9]{2}-[0-9]{2}$",
                "placeholder": 'YYYY-MM-DD'
            },
            "helperText": [
                'Select dates that are greater than or equal to this date.'
            ]
        },
        {
            "key": "filterDateTo",
            "label": "Date To",
            "attrs": {
                "type": "text",
                "pattern": "^[0-9]{4}-[0-9]{2}-[0-9]{2}$",
                "placeholder": 'YYYY-MM-DD'
            },
            "helperText": [
                'Select dates that are less than or equal to this date.'
            ]
        },
        {
            "key": "filterJobID",
            "label": "JobIDs",
            "attrs": {
                "type": "text",
                "pattern": "^[0-9,\\t ]+$"
            },
            "helperText": [
                'Comma or space delimmited list of JobIDs.'
            ]
        },
        {
            "key": `includeJournyInfo`,
            "label": 'Include Journey Name and Version Where Relevant',
            "attrs": {
                "type": "checkbox",
                "true-value": 'true',
                "false-value": 'false'
            },
            "helperText": [
                'Requires an extra query to be run.  Will take an extra 2-3 minutes to complete.'
            ]
        }
    ]
};
var formDefaultValues = {
    contactAttributeType: 'SubscriberKey',
    includeJournyInfo: 'false',
    ...((
        () => {
            var values = {};
            Object.keys(formInputs).forEach((k) => {
                if (k.match(/^eventTypes/)) {
                    formInputs[k].forEach((eventType) => {
                        values[eventType.key] = 'true';
                    });
                }
            });
            return values;
        }
    )())
};

var resultPropertyMapper = (property) => {
    if (typeof property == 'string') {
        property = {
            api: property,
            result: property
        }
    }
    if (!property.result) {
        property.result = property.api;
    }
    if (typeof property.retrievable == 'undefined') {
        property.retrievable = true;
    }
    if (typeof property.hidden == 'undefined') {
        property.hidden = false;
    }
    if (!property.map) {
        if (property.api == property.result) {
            property.map = function() {};
        } else {
            property.map = function(result) {
                result[this.result] = result[this.api];
                //delete result[this.api];
            };
        }
    }
    return property;
};
var resultProperties = {
    eventTracking: [
        {
            api: 'TriggeredSendDefinitionObjectID',
            hidden: true
        },
        {
            api: 'SubscriberKey',
            result: 'ContactKey'
        },
        {
            api: 'Client.ID',
            result: 'MID',
            map: function (result) {
                if (result.Client) {
                    result[this.result] = result.Client.ID;
                    delete result.Client
                }
            }
        },
        'EventType',
        'EventDate',
        {
            api: 'SendID',
            result: 'JobID'
        },
        {
            api: 'EmailName',
            retrievable: false
        },
        {
            api: 'JourneyName',
            retrievable: false
        },
        {
            api: 'JourneyVersion',
            retrievable: false
        }
    ].map(resultPropertyMapper)
};

export default {
    name: 'RetrieveTrackingEventsView',
    components: {
        FormInputGroupView,
        DERowsTable
    },
    data: function() {
        var data = {
            uiState: 'ready',
            form: {
                inputs: FormInputGroup.makeInputs(formInputs),
                values: FormInputGroup.makeValues(formInputs, formDefaultValues),
                valuesSubmitted: FormInputGroup.makeValues(formInputs, formDefaultValues)
            },
            emailAddresses: [],
            subscriberKeys: [],
            contacts: [],
            events: [],
            retrievalSeq: 1,
            retrievalsCount: 0,
            retrievalsComplete: 0,
            retrievalErrors: 0,
            retrievalMessages: [],
            jobs: {},
            journeyTriggers: {},
            resultHeadersAll: (() => {
                var headers = [];
                Object.keys(resultProperties).forEach((k) => {
                    resultProperties[k].forEach((property) => {
                        if (
                            !property.hidden &&
                            (headers.indexOf(property.result) == -1)
                         ) {
                            headers.push(property.result);
                        }
                    });
                });
                return headers;
            })(),
            resultHeaders: [],
            results: [],
            resultsStaging: []
        };
        return data;
    },
    methods: {
        isUIState: function(target) {
            return this.uiState.match(new RegExp(target));
        },
        formChange: function(event) {
            this.form.values[event.key] = event.value;
        },
        onChangeContactAttributeType: function() {
            if (this.form.values.contactAttributeType == 'SubscriberKey') {
                this.formInputs.get('emailAddresses').visible = false;
                this.formInputs.get('subscriberKeys').visible = true;
                this.form.values.emailAddresses = '';
            } else {
                this.formInputs.get('emailAddresses').visible = true;
                this.formInputs.get('subscriberKeys').visible = false;
                this.form.values.subscriberKeys = '';
            }
        },
        selectEvents: function(toggleType, eventsTypeKey) {
            var toggle = (toggleType == 'all') ? 'true' : 'false';
            if (this.isUIState('ready')) {
                this.form.inputs[eventsTypeKey].forEach((input) => {
                    this.form.values[input.key] = toggle;
                })
            }
        },
        getEmailNameFromJobID: function(jobId) {
            return this.sfmc.apiCall(
                'retrieve',
                {
                    object_type: 'Send',
                    get_properties: ['EmailName'],
                    search_property: 'ID',
                    search_property_value: jobId,
                    query_all_accounts: true,
                    single_result: true
                }
            ).then(
                (response) => {
                    if (response.data && response.data.EmailName) {
                        this.jobs[jobId] = response.data.EmailName;
                    }
                    return Promise.resolve();
                }
            );
        },
        getJourneysFromTriggeredSendDefinitionObjectIDs: function(triggeredSendDefinitionObjectIDs) {
            var chunks = [[]];
            var chunkSize = 32;
            var queries = [Promise.resolve()];
            triggeredSendDefinitionObjectIDs.forEach((id) => {
                chunks[0].push(id);
                if (chunks[0].length == chunkSize) {
                    chunks.unshift([]);
                }
            });
            chunks.forEach((ids) => {
                var query;
                if (ids.length) {
                    query = new QueryRunner(
                        this,
                        `select
                            journey.JourneyName, 
                            journey.VersionNumber,
                            activity.JourneyActivityObjectID
                        from
                            _JourneyActivity as activity
                        inner join
                            _Journey as journey
                            on
                                journey.VersionID = activity.VersionID
                        where
                            activity.ActivityType = 'EMAILV2' and
                            activity.JourneyActivityObjectID in ('${ids.join("','")}')`,
                        {
                            responseRender: QueryRunner.RESPONSE_IGNORE,
                            retrieveResultObject: true
                        }
                    );
                    queries.push(query.run().then(
                        () => {
                            query.queryResultObject.forEach((row) => {
                                this.journeyTriggers[row.JourneyActivityObjectID.toLowerCase()] = {
                                    name: row.JourneyName,
                                    version: row.VersionNumber
                                };
                            });
                        }
                    ));
                }
            });
            return Promise.all(queries);
        },
        pushResult: function(result) {
            var row = {}, journeyData;
            this.resultHeaders.forEach((resultHeader) => {
                if (typeof result[resultHeader] != 'undefined') {
                    row[resultHeader] = result[resultHeader];
                } else {
                    row[resultHeader] = '';
                }
            });

            if (typeof result.JobID != 'undefined') {
                row['EmailName'] = this.jobs[result.JobID];
            }

            if (
                (this.form.valuesSubmitted.includeJournyInfo == 'true') &&
                (typeof result.TriggeredSendDefinitionObjectID != 'undefined') &&
                (result.TriggeredSendDefinitionObjectID !== null)
            ) {
                journeyData = this.journeyTriggers[result.TriggeredSendDefinitionObjectID.toLowerCase()];
                if (journeyData) {
                    row['JourneyName'] = journeyData.name;
                    row['JourneyVersion'] = journeyData.version;
                }
            }

            //console.log('jobs', JSON.stringify(this.jobs, null, 3));
            //console.log('pushResult()', JSON.stringify(row, null, 3));
            this.results.push(row);
        },
        coallateResults: function(results, resultProperties) {
            results.forEach((result) => {
                resultProperties.forEach((property) => {
                    property.map(result);
                });
            });
            return results;
        },
        retrieveEventTracking: function(retrievalData, formValues) {
            var filter, jobIdFilter;

            filter = this.sfmc.simpleFilter(
                'SubscriberKey',
                retrievalData.subscriberKey
            );
            if (formValues.filterDateFrom) {
                filter = this.sfmc.complexFilter(
                    filter,
                    'AND',
                    this.sfmc.simpleFilter(
                        'EventDate',
                        formValues.filterDateFrom,
                        'greaterThanOrEqual',
                        'DateValue'
                    )
                );
            }
            if (formValues.filterDateTo) {
                filter = this.sfmc.complexFilter(
                    filter,
                    'AND',
                    this.sfmc.simpleFilter(
                        'EventDate',
                        (new Date((new Date(formValues.filterDateTo)).getTime() + (86400 * 1000))).toISOString(),
                        'lessThanOrEqual',
                        'DateValue'
                    )
                );
            }

            if (formValues.filterJobID) {
                jobIdFilter = null;
                formValues.filterJobID.split(/[, ]+/).forEach((jobId) => {
                    if (!jobIdFilter) {
                        jobIdFilter = this.sfmc.simpleFilter(
                            'SendID',
                            jobId
                        );
                    } else {
                        jobIdFilter = this.sfmc.complexFilter(
                            jobIdFilter,
                            'OR',
                            this.sfmc.simpleFilter(
                                'SendID',
                                jobId
                            )
                        );
                    }
                });
                filter = this.sfmc.complexFilter(
                    jobIdFilter,
                    'AND',
                    filter
                );
            }

            return this.sfmc.apiCall(
                'retrieve',
                {
                    object_type: retrievalData.eventObjectType,
                    get_properties: resultProperties.eventTracking.flatMap((property) => (property.retrievable ? [property.api] : [])),
                    complex_filter: filter,
                    query_all_accounts: true
                }
            ).then(
                (response) => {
                    if (response.overall_status == 'MoreDataAvailable') {
                        this.retrievalMessages.push(
                            `Only the first 2500 ${retrievalData.eventObjectType} records are shown for contact key ${retrievalData.subscriberKey}.  Narrow the date range or enter a JobID to reduce the number of events returned.`
                        );
                    }
                    return Promise.resolve(this.coallateResults(response.data, resultProperties.eventTracking));
                }
            );
        },
        getContactData: function(properties, propertiesType) {
            var subscribers = [];
            var contacts = [];
            var apiCalls = [];
            properties.forEach((property) => {
                apiCalls.push(
                    this.sfmc.apiCall(
                        'retrieve',
                        {
                            object_type: 'Subscriber',
                            get_properties: ['Status', 'SubscriberKey'],
                            search_property: propertiesType,
                            search_property_value: property,
                            query_all_accounts: true
                        }
                    ).then(
                        (response) => {
                            response.data.forEach((result) => {
                                if (!subscribers.find((subscriber) => (subscriber.SubscriberKey == result.SubscriberKey))) {
                                    subscribers.push(result);
                                }
                            });
                        }
                    )
                );
                if (propertiesType == 'EmailAddress') {
                    apiCalls.push(
                        this.sfmcRest.apiCall({
                            resource: '/contacts/v1/addresses/email/search',
                            method: 'POST',
                            data: {
                                "ChannelAddressList": [property],
                                "MaximumCount": 16
                            }
                        }).then(
                            (response) => {
                                if (
                                    response.data.channelAddressResponseEntities &&
                                    response.data.channelAddressResponseEntities.length
                                ) {
                                    response.data.channelAddressResponseEntities.forEach((channelAddressResponseEntity) => {
                                        channelAddressResponseEntity.contactKeyDetails.forEach((result) => {
                                            if (!contacts.find((contact) => (contact.contactKey == result.contactKey))) {
                                                contacts.push({
                                                    contactKey: result.contactKey
                                                });
                                            }
                                        });
                                    });
                                }
                            }
                        )
                    );
                } else {
                    contacts.push({
                        contactKey: property
                    });
                }
            });
            return Promise.all(apiCalls).then(
                () => {
                    contacts.forEach((contact) => {
                        var subscriber = subscribers.find((subscriber) => (subscriber.SubscriberKey == contact.contactKey));
                        if (subscriber) {
                            contact.subscriber = subscriber;
                        } else {
                            contact.subscriber = {};
                        }
                    });
                    return Promise.resolve(contacts);
                }
            );
        },
        submit: function() {
            var apiCalls = [Promise.resolve()];
            var formValues = JSON.parse(JSON.stringify(this.form.values));
            var emailAddresses = JSON.parse(JSON.stringify(this.emailAddresses));
            var subscriberKeys = JSON.parse(JSON.stringify(this.subscriberKeys));

            if (this.uiState != 'ready') {
                return Promise.resolve();
            }

            this.form.valuesSubmitted = formValues;

            this.resultHeaders = this.resultHeadersAll.flatMap((header) => {
                if (
                    (formValues.includeJournyInfo  == 'true') ||
                    (
                        (formValues.includeJournyInfo == 'false') &&
                        (!header.match(/^(JourneyName|JourneyVersion)$/))
                    )
                ) {
                    return [header];
                } else {
                    return [];
                }
            });

            this.events = [];
            Object.keys(formValues).forEach((formValueKey) => {
                if (
                    (formValues[formValueKey] == 'true') &&
                    formValueKey.match(/^eventType/)
                ) {
                    this.events.push(formValueKey);
                }
            });
            if (!this.events.length) {
                alert('No events selected to retrieve.');
                this.uiState = 'ready';
                return Promise.resolve();
            }

            this.contacts = [];
            this.results = [];
            this.resultsStaging = [];
            this.retrievalsCount = 0;
            this.retrievalsComplete = 0;
            this.retrievalErrors = 0;
            this.retrievalMessages = [];
            this.uiState = 'retrieving';
            return Promise.resolve().then(
                () => {
                    if (formValues.contactAttributeType == 'EmailAddress') {
                        return this.getContactData(emailAddresses, 'EmailAddress');
                    } else {
                        return this.getContactData(subscriberKeys, 'SubscriberKey');
                    }
                }
            ).then(
                (contacts) => {
                    this.contacts = contacts;

                    if (!this.contacts.length) {
                        alert('No matching contacts.')
                        this.uiState = 'ready';
                        return Promise.resolve();
                    }

                    this.contacts.forEach((contact) => {
                        this.events.forEach((formValueKey) => {
                            var eventObjectType = formValueKey.replace(/^eventType/, '')+'Event';
                            this.retrievalsCount++;
                            apiCalls.push(
                                this.retrieveEventTracking(
                                    {
                                        id: this.retrievalSeq++,
                                        subscriberKey: contact.contactKey,
                                        eventObjectType
                                    },
                                    formValues
                                ).then(
                                    (result) => {
                                        this.resultsStaging.push(...result);
                                        this.retrievalsComplete++;
                                        return Promise.resolve();
                                    },
                                    () => {
                                        this.retrievalErrors++;
                                        this.retrievalsComplete++;
                                        return Promise.resolve();
                                    }
                                )
                            );
                        });
                    });
                    return Promise.all(apiCalls);
                }
            ).then(
                () => {
                    var apiCalls = [Promise.resolve()];
                    var triggeredSendDefinitionObjectIDs = [];
                    this.uiState = 'retrieving:extras'
                    this.resultsStaging.forEach((result) => {
                        if (
                            result.JobID &&
                            (typeof this.jobs[result.JobID] == 'undefined')
                        ) {
                            this.jobs[result.JobID] = '';
                            apiCalls.push(this.getEmailNameFromJobID(result.JobID));
                        }

                        if (
                            (formValues.includeJournyInfo == 'true') &&
                            result.TriggeredSendDefinitionObjectID &&
                            (typeof this.journeyTriggers[result.TriggeredSendDefinitionObjectID.toLowerCase()] == 'undefined')
                        ) {
                            this.journeyTriggers[result.TriggeredSendDefinitionObjectID.toLowerCase()] = {
                                name: '',
                                version: ''
                            };
                            triggeredSendDefinitionObjectIDs.push(result.TriggeredSendDefinitionObjectID.toLowerCase());
                        }
                    });

                    if (formValues.includeJournyInfo == 'true') {
                        apiCalls.push(
                            this.getJourneysFromTriggeredSendDefinitionObjectIDs(triggeredSendDefinitionObjectIDs)
                        );
                    }

                    return Promise.all(apiCalls);
                }
            ).then(
                () => {
                    this.resultsStaging.forEach((result) => {
                        this.pushResult(result);
                    });
                    this.uiState = 'ready';
                    return Promise.resolve();
                }
            ).catch(
                (e) => {
                    // eslint-disable-next-line no-console
                    console.error(e);
                }
            );
        },
        downloadToCsv: function() {
            var resultsToRows = (results) => {
                var rows = [], headers = [];
                results.forEach((result) => {
                    var row = [];
                    if (!headers.length) {
                        headers = Object.keys(result);
                        rows.push(headers);
                    }
                    headers.forEach((header) => {
                        row.push(result[header]);
                    });
                    rows.push(row);
                });
                return rows;
            };
            var rows = resultsToRows(this.results);
            var ws = XLSX.utils.aoa_to_sheet(rows);
            return downloadFiles(
                [
                    {
                        name: `RetrieveTrackingEvents.csv`,
                        content: XLSX.utils.sheet_to_csv(ws),
                        type: 'text/csv'
                    }
                ], 
                `RetrieveTrackingEvents.zip`
            );
        },
        objectPluralify: function(objectLabel, object) {
            return `${objectLabel}${(object.length != 1) ? 's' : ''}`;
        }
    },
    created: function() {
        this.sfmc = flywhweelSFMCUtilFactory(this);
        this.sfmcRest = flywhweelSFMCUtilFactory(this, 'rest');
        this.sfmcFolder = flywhweelSFMCUtilFactory(this, 'folder');
        this.formInputs = FormInputGroup.util(() => this.form.inputs);
    },
    mounted: function() { 
        this.onChangeContactAttributeType();
        //setTimeout(() => { this.form.values.subscriberKeys = 'dagarwal@merkleinc.com mpatil@merkleinc.com'; }, 69);
        //setTimeout(() => { this.form.values.subscriberKeys = 'ptrckhyns+2020.05.15T16.27.05.158322.3@gmail.com'; }, 69);
        //setTimeout(() => { this.form.values.subscriberKeys = '0036g00000Mxz3AAAR,ptrckhyns+2020.05.15T16.27.05.158322.3@gmail.com'; }, 69);
        //setTimeout(() => { this.form.values.subscriberKeys = '0036g00000Mxz3AAAR'; }, 69);
    },
    watch: {
        'form.values.contactAttributeType': function() {
            this.onChangeContactAttributeType();
        },
        'form.values.emailAddresses': function() {
            this.emailAddresses = this.form.values.emailAddresses.split(/[\s,]+/).flatMap((t) => {
                if (t.match(/[\s,]+/)) {
                    return [];
                } else if (t.match(/^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
                    return [t];
                } else {
                    return [];
                }
            });
        },
        'form.values.subscriberKeys': function() {
            this.subscriberKeys = this.form.values.subscriberKeys.split(/[\s,]+/).flatMap((t) => {
                if (!t.length || t.match(/^[\s,]+$/)) {
                    return [];
                } else {
                    return [t];
                }
            });
        },
        uiState: function() {
            if (this.isUIState('retrieving')) {
                this.formInputs.forEach((input) => {
                    input.attrs.disabled = true;
                });
            } else if (this.isUIState('ready')) {
                this.formInputs.forEach((input) => {
                    input.attrs.disabled = false;
                });
            }
        },
        retrievalsComplete: function() {
            if (
                (this.uiState == 'retrieving') &&
                this.retrievalsCount &&
                this.retrievalsComplete &&
                (this.retrievalsComplete == this.retrievalsCount)
            ) {
                this.uiState = 'ready';
            }
        }
    }
}
</script>
<template src="./RetrieveTrackingEvents.html"></template>
<style lang="scss" src="./RetrieveTrackingEvents.scss"></style>